import React, { useState } from 'react';
import styles from './curd.module.scss';
import { KoCheckBox, KoFormBuilder, KoNumber } from 'packages';

export default function Shipping({ form, product }) {
  const [disabled, setDisabled] = useState(true);

  const handleCheckChange = (e) => {
    setDisabled(!e.target.checked); // if checked → enable, else disable
  };

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: product,
    colon: true,
    fields: [
      {
        title: 'PhysicalProduct',
        key: 'physicalProduct',
        width: 200,
        colSpan: 4,
        render: () => (
          <KoCheckBox
            onChange={handleCheckChange}
            label={'This is a physical product'}
          />
        )
      },
      {
        key: 'weight',
        label: 'Weight',
        colSpan: 2,
        widget: KoNumber,
        placeholder: 'Product weight...',
        disabled: disabled,
        rules: [
          {
            required: true,
            message: 'Weight is required'
          }
        ]
      },
      {
        key: 'height',
        label: 'Height',
        colSpan: 2,
        widget: KoNumber,
        placeholder: 'Height(cm)...',
        disabled: disabled,
        rules: [
          {
            required: true,
            message: 'Height is required'
          }
        ]
      },
      {
        key: 'length',
        label: 'Length',
        colSpan: 2,
        widget: KoNumber,
        placeholder: 'Length(cm)...',
        disabled: disabled,
        rules: [
          {
            required: true,
            message: 'Length is required'
          }
        ]
      },
      {
        key: 'width',
        label: 'Width',
        colSpan: 2,
        widget: KoNumber,
        placeholder: 'Width(cm)...',
        disabled: disabled,
        rules: [
          {
            required: true,
            message: 'Width is required'
          }
        ]
      }
    ]
  };

  return (
    <div className={styles.wrapper}>
      <KoFormBuilder form={form} meta={meta} />
    </div>
  );
}
